import { useQuery } from '@tanstack/react-query';

import { useApi } from '../_shared/hooks';
import { getLibrary } from './api-client';
import { libraryQueryKey } from './query-keys';

/**
 * The whole library (segmentations/sequences/playbooks) under the SAME query
 * key `PlaybooksHome.tsx`'s (now-removed) inline query and
 * `PlaybooksConfigPage.tsx` both already use (`libraryQueryKey()`) —
 * a create from either the Config page or `CreatePlaySidebar` invalidates
 * one shared cache entry, not two.
 *
 * Play isolation (plan 2026-09-25-002, U5) — the optional `playId` also
 * lists that play's own segmentations and sequences (Decision 12); every
 * existing caller omits it and keeps reading the unscoped template list.
 */
export function usePlaybooksLibrary(playId?: string) {
  const { apiFetch } = useApi();
  return useQuery({
    queryKey: libraryQueryKey(playId),
    queryFn: () => getLibrary(apiFetch, { playId }),
    staleTime: Infinity,
  });
}
